"use client";
import { useEffect, useState } from "react";
import { usePathname } from "@/i18n/navigation";
import Header from "@/components/auth/header/Header";
import dynamic from "next/dynamic";
import GoogleAd from "@/app/[locale]/[type]/_component/GoogleAd";
import { useSearchParams } from "next/navigation";
import { GoogleTagPageView } from "@/components/analytics/GoogleTagPageView";

const Footer = dynamic(() => import("@/components/auth/footer/Footer"));

export default function LayoutShell({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Avoid hydration mismatch: pathname and GoogleAd (window check) can differ
  // server vs client. Defer pathname-dependent and client-only content until mounted.
  const isDrawPage =
    mounted && pathname != null && pathname.includes("/draw");

  const isCalcFullScreen =
    mounted &&
    pathname != null &&
    (pathname.includes("/full-screen-calculator") || pathname.includes("/scientific-calculator")) &&
    searchParams.get("fullscreen") === "1";

  const hideHeaderFooter = isCalcFullScreen;

  return (
    <>
      <GoogleTagPageView />
      {!hideHeaderFooter && (
        <Header minimal={isDrawPage} />
      )}
      <main className={hideHeaderFooter ? "calc-fullscreen-main" : undefined}>
        {children}
      </main>
      {mounted && !isDrawPage && !hideHeaderFooter && (
        <>
          <GoogleAd slot="1234567890" format="auto" />
          <Footer />
        </>
      )}
    </>
  );
}
